// src/data/filingFormTypes.js
// SEC-FILINGS-PAGE — new file.
//
// Frontend display list for the form-type filter dropdown. This is a
// DELIBERATE, DOCUMENTED mirror of backend/jobs/edgarFormConfig.js's
// FORM_CONFIG label field — frontend code cannot import a backend/jobs
// file directly, so the label strings are duplicated here for display
// purposes only (no significance/quota/tier logic, which stays backend-only
// and is never re-derived on this side).
//
// IF A FORM TYPE IS ADDED TO edgarFormConfig.js, ADD IT HERE TOO — this is
// the one place in the frontend where that list can silently go stale.
// Flagging this explicitly rather than let it drift unnoticed later.

export const FORM_TYPES = [
  { code: '8-K',      label: 'Material Event',              category: 'MATERIAL_EVENT' },
  { code: '8-K/A',    label: 'Material Event (Amended)',     category: 'MATERIAL_EVENT' },
  { code: '10-Q',     label: 'Quarterly Report',             category: 'QUARTERLY' },
  { code: '10-Q/A',   label: 'Quarterly Report (Amended)',   category: 'QUARTERLY' },
  { code: '10-K',     label: 'Annual Report',                category: 'ANNUAL' },
  { code: '10-K/A',   label: 'Annual Report (Amended)',       category: 'ANNUAL' },
  { code: 'S-1',      label: 'IPO Registration',              category: 'CAPITAL' },
  { code: 'S-1/A',    label: 'IPO Registration (Amended)',    category: 'CAPITAL' },
  { code: 'S-3',      label: 'Shelf Registration',            category: 'CAPITAL' },
  { code: '424B4',    label: 'Prospectus (Capital Raise)',    category: 'CAPITAL' },
  { code: '424B5',    label: 'Follow-On Offering',            category: 'CAPITAL' },
  { code: '424B1',    label: 'Prospectus Supplement',         category: 'CAPITAL' },
  { code: '424B3',    label: 'Prospectus (Pricing)',          category: 'CAPITAL' },
  { code: 'S-4',      label: 'Merger Registration',           category: 'CAPITAL' },
  { code: 'SC TO-T',  label: 'Tender Offer (M&A)',            category: 'CAPITAL' },
  { code: 'SC TO-I',  label: 'Issuer Tender Offer',           category: 'CAPITAL' },
  { code: 'SC TO-C',  label: 'Tender Offer Communication',    category: 'CAPITAL' },
  { code: '425',      label: 'M&A Prospectus',                category: 'CAPITAL' },
  { code: 'F-1',      label: 'Foreign IPO Registration',      category: 'CAPITAL' },
  { code: 'F-1/A',    label: 'Foreign IPO (Amended)',         category: 'CAPITAL' },
  { code: 'F-3',      label: 'Foreign Shelf Registration',    category: 'CAPITAL' },
  { code: '8-A12B',   label: 'Exchange Listing Registration', category: 'CAPITAL' },
  { code: '20-F',     label: 'Annual Report (Foreign)',       category: 'FOREIGN' },
  { code: '20-F/A',   label: 'Annual Report (Foreign Amend)', category: 'FOREIGN' },
  { code: '6-K',      label: 'Current Report (Foreign)',      category: 'FOREIGN' },
  { code: '6-K/A',    label: 'Current Report (Foreign Amend)',category: 'FOREIGN' },
  { code: '40-F',     label: 'Annual Report (Canadian)',      category: 'FOREIGN' },
  { code: 'SC 13D',   label: 'Activist Accumulation (\u226525%)', category: 'ACTIVIST' },
  { code: 'SC 13D/A', label: 'Activist Accumulation (Amend)', category: 'ACTIVIST' },
  { code: 'SC 13G',   label: 'Passive Accumulation (\u22655%)',   category: 'ACTIVIST' },
  { code: 'SC 13G/A', label: 'Passive Accumulation (Amend)',  category: 'ACTIVIST' },
  { code: 'SC 13E-3', label: 'Going Private Transaction',     category: 'ACTIVIST' },
  { code: 'DEF 14A',  label: 'Proxy Statement',               category: 'GOVERNANCE' },
  { code: 'DEFC14A',  label: 'Contested Proxy Statement',     category: 'GOVERNANCE' },
  { code: 'DEFM14A',  label: 'Merger Proxy Statement',        category: 'GOVERNANCE' },
  { code: 'DEFA14A',  label: 'Additional Proxy Materials',    category: 'GOVERNANCE' },
  { code: 'PRE 14A',  label: 'Preliminary Proxy Statement',   category: 'GOVERNANCE' },
  { code: 'NT 10-K',  label: 'Late Annual Report',            category: 'DISTRESS' },
  { code: 'NT 10-Q',  label: 'Late Quarterly Report',         category: 'DISTRESS' },
  { code: '15-12B',   label: 'Deregistration (Exchange)',     category: 'DISTRESS' },
  { code: '15-12G',   label: 'Deregistration (Going Dark)',   category: 'DISTRESS' },
  { code: '25',       label: 'Delisting Notification',        category: 'DISTRESS' },
  { code: '25-NSE',   label: 'Delisting (National Exchange)', category: 'DISTRESS' },
  { code: 'Form 4',   label: 'Insider Trade',                 category: 'INSIDER' },
  { code: 'Form 4/A', label: 'Insider Trade (Amended)',       category: 'INSIDER' },
  { code: 'Form 3',   label: 'New Insider (Initial Filing)',  category: 'INSIDER' },
  { code: 'Form 5',   label: 'Insider Annual Summary',        category: 'INSIDER' },
  { code: 'Form 144', label: 'Insider Selling Intent',        category: 'INSIDER' },
];

export function formTypesForCategory(category) {
  return category ? FORM_TYPES.filter(f => f.category === category) : FORM_TYPES;
}
